// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 12402-获取商品规则详情 查询核销方式、可用泳池、适用年龄段 GET /web/v1/goods/rule/detail/${param0} */
export async function detail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.detailParams,
  options?: { [key: string]: any },
) {
  const { goodsId: param0, ...queryParams } = params;
  return request<API.YmResultVOGoodsRuleDetailResp>(
    `/web/v1/goods/rule/detail/${param0}`,
    {
      method: 'GET',
      params: { ...queryParams },
      ...(options || {}),
    },
  );
}

/** 12401-保存商品规则 保存核销方式、可用泳池、适用年龄段（直接落表） POST /web/v1/goods/rule/save */
export async function save(
  body: API.GoodsRuleSaveReq,
  options?: { [key: string]: any },
) {
  return request<API.YmResultVOBoolean>('/web/v1/goods/rule/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}
